import { BsPublicResourceTable } from './BsPublicResourceTable';
export default BsPublicResourceTable;
